import cloneDeep from 'lodash.clonedeep';

export default class {
  constructor() {
    this.past = [];
    this.current = null;
    this.future = [];
    this.isSaving = false;
    this.isSaved = false;
    this.lastSave = null;
  }

  add(el) {
    this.past.push(cloneDeep(el));
  }

  back() {
    this.future.push(this.past.pop());
    return cloneDeep(this.past[this.past.length - 1]);
  }

  forward() {
    this.past.push(this.future.pop());
    return cloneDeep(this.past[this.past.length - 1]);
  }

  saving() {
    this.isSaved = false;
    this.isSaving = true;
  }

  saved(savedTime) {
    this.isSaving = false;
    this.isSaved = true;

    if (savedTime) {
      this.lastSave = savedTime;
    }
  }
}
